import { apiSlice } from '../../../store/apiSlice';
import {
  Credentials,
  EmpresaResponse,
  LoginResponse,
  RegisterPayload,
  VerifySessionResponse,
} from '../types';

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, Credentials>({
      query: credentials => ({
        url: '/platform/auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['User'],
    }),
    verifySession: builder.query<VerifySessionResponse, void>({
      query: () => '/platform/auth/verify',
      providesTags: ['User'],
    }),
    register: builder.mutation<{ success: boolean; user: unknown }, RegisterPayload>({
      query: userInfo => ({
        url: '/platform/auth/register',
        method: 'POST',
        body: userInfo,
      }),
      invalidatesTags: ['User'],
    }),
    logout: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({
        url: '/platform/auth/logout',
        method: 'POST',
      }),
      invalidatesTags: ['User', 'Empresa'],
    }),
    listEmpresas: builder.query<{ success: boolean; data: EmpresaResponse[] }, void>({
      query: () => '/empresas',
      providesTags: ['Empresa'],
    }),
    createEmpresa: builder.mutation<
      { success: boolean; data: EmpresaResponse },
      { nombre: string; descripcion?: string }
    >({
      query: body => ({
        url: '/empresas',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Empresa'],
    }),
  }),
});

export const {
  useLoginMutation,
  useVerifySessionQuery,
  useLazyVerifySessionQuery,
  useRegisterMutation,
  useLogoutMutation,
  useListEmpresasQuery,
  useCreateEmpresaMutation,
} = authApiSlice;
